import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const header: SxStyle = {
  position: 'sticky',
  top: 0,
  zIndex: 10,
  padding: (p) => p.spacing(2),
  borderRadius: (p) => p.spacing(1.5),
  backgroundColor: (p) => p.palette.grey[100],
};
